import { FeatureItemValueTypeEnum } from '../modules/base/enums/feature-item-value-type.enum';

/**
 * Parse a feature item value string according to its valueType.
 * Defaults to STRING when valueType is missing or invalid.
 */
export function parseFeatureItemValue(
	value: string | undefined,
	valueType: FeatureItemValueTypeEnum,
): unknown {
	switch (valueType) {
		case FeatureItemValueTypeEnum.NUMBER:
			return parseFloat(value ?? '');
		case FeatureItemValueTypeEnum.BOOL:
			return value === 'true';
		case FeatureItemValueTypeEnum.JSON:
			return value ? JSON.parse(value) : null;
		default:
			return value ?? '';
	}
}
